(function ($) {
  var $ = jQuery = $;
  jQuery(window).scroll(function () {
    if (jQuery(window).scrollTop() >= 100) {
      //jQuery('#shopify-section-header').addClass('fixed-header');
    } else {
      //jQuery('#shopify-section-header').removeClass('fixed-header');
    }
  });

  $(document).ready(function () {
    jQuery('#shopify-section-product-template .theme-gallery .swiper-container').css('height', '100%');
    setTimeout(function () {
      $("#newsletter_wrapper .ctct-form-element").attr("placeholder", "Enter email address");
    }, 3000);

    var checkExist = setInterval(function () {
      if ($('.privy-popup-content-wrap').length) {
        jQuery('.privy-popup-content-wrap .powered-by img').remove();
        clearInterval(checkExist);
      }
    }, 100); // check every 100ms

    if (document.cookie.indexOf("tworld-campaign") >= 0) {
      hide_campaign_modal();
    } else {
      show_campaign_modal();
    }

    jQuery('.close-modal').on('click', function () {
      hide_campaign_modal();
      var date = new Date();
      date.setTime(+date + (24 * 3600000));
      window.document.cookie = "tworld-campaign=1; expires=" + date.toGMTString();
    });
    
    /* LIGHTENING SCHEDULER */
    // $Lightning.use("runtime_appointmentbooking:lightningOutGuest",
    //   function() {                  // Callback once framework and app load
    //       $Lightning.createComponent(
    //           "lightning:flow",    // top-level component of your app
    //           { },    // attributes to set on the component when created
    //           "lexcontainer",    // the DOM location to insert the component
    //           function(component) { // API name of the Flow
    //               component.startFlow("Inbound_Guest_Appointment");
    //           }
    //       );
    //   },    'https://honmagolf.force.com/inboundscheduler'  // Community endpoint
    // );
	/* END LIGHTENING SCHEDULER */

  });

  function show_campaign_modal() {
    jQuery('#page-honma-golf-official-us-amp-ca-honma-golf-store #tworld-campaign,#page-honma-golf-official-us-amp-ca-honma-golf-store .tworld-campaign-backdrop').addClass('in').show();
  }

  function hide_campaign_modal() {
    jQuery('#tworld-campaign,.tworld-campaign-backdrop').removeClass('in').hide();
  }



  $(document).ready(function () {
    setTimeout(function () {
      $("#newsletter_wrapper .ctct-form-element").attr("placeholder", "Enter email address");
      $(".form-wrapper #email_address_3").attr("placeholder", "Enter email address");
      $(".form-wrapper #first_name_3").attr("placeholder", "FIRST NAME");
      $(".form-wrapper #last_name_3").attr("placeholder", "LAST NAME");
      $(".form-wrapper #last_name_3").attr("placeholder", "LAST NAME");
      $(".form-wrapper #city_3").attr("placeholder", "City");
      $(".form-wrapper #state_3").attr("placeholder", "State");
      $(".form-wrapper #postal_code_3").attr("placeholder", "Postal Code");
      $(".form-wrapper #email_address_0").attr("placeholder", "Enter email address");
      $(".form-wrapper #first_name_0").attr("placeholder", "FIRST NAME");
      $(".form-wrapper #last_name_0").attr("placeholder", "LAST NAME");
      $(".form-wrapper #last_name_0").attr("placeholder", "LAST NAME");
      $(".form-wrapper #city_0").attr("placeholder", "City");
      $(".form-wrapper #state_0").attr("placeholder", "State");
      $(".form-wrapper #postal_code_0").attr("placeholder", "Postal Code");
      $(".form-wrapper #email_address_1").attr("placeholder", "Enter email address");
      $(".form-wrapper #first_name_1").attr("placeholder", "FIRST NAME");
      $(".form-wrapper #last_name_1").attr("placeholder", "LAST NAME");
      $(".form-wrapper #last_name_1").attr("placeholder", "LAST NAME");
      $(".form-wrapper #city_1").attr("placeholder", "City");
      $(".form-wrapper #state_1").attr("placeholder", "State");
      $(".form-wrapper #postal_code_1").attr("placeholder", "Postal Code");
      $(".form-wrapper #email_address_2").attr("placeholder", "Enter email address");
      $(".form-wrapper #first_name_2").attr("placeholder", "FIRST NAME");
      $(".form-wrapper #last_name_2").attr("placeholder", "LAST NAME");
      $(".form-wrapper #last_name_2").attr("placeholder", "LAST NAME");
      $(".form-wrapper #city_2").attr("placeholder", "City");
      $(".form-wrapper #state_2").attr("placeholder", "State");
      $(".form-wrapper #postal_code_2").attr("placeholder", "Postal Code");
      $(".form-wrapper #email_address_4").attr("placeholder", "Enter email address");
      $(".form-wrapper #first_name_4").attr("placeholder", "FIRST NAME");
      $(".form-wrapper #last_name_4").attr("placeholder", "LAST NAME");
      $(".form-wrapper #last_name_4").attr("placeholder", "LAST NAME");
      $(".form-wrapper #city_4").attr("placeholder", "City");
      $(".form-wrapper #state_4").attr("placeholder", "State");
      $(".form-wrapper #postal_code_4").attr("placeholder", "Postal Code");
      $(".form-wrapper #email_address_6").attr("placeholder", "Enter email address");
      $(".form-wrapper #first_name_6").attr("placeholder", "FIRST NAME");
      $(".form-wrapper #last_name_6").attr("placeholder", "LAST NAME");
      $(".form-wrapper #last_name_6").attr("placeholder", "LAST NAME");
      $(".form-wrapper #city_6").attr("placeholder", "City");
      $(".form-wrapper #state_6").attr("placeholder", "State");
      $(".form-wrapper #postal_code_6").attr("placeholder", "Postal Code");
    }, 1000);

  });


  $(document).ready(function () {
    $('.smooth-scroll').on('click', function (evt) {
      evt.preventDefault();
      $('html, body').animate({
          scrollTop: $($(this).attr('href')).offset().top
        },
        300
      );
    });
  });
  

  $(document).ready(function () {
    var acc = document.getElementsByClassName("expand-menu");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }
  });

  $(document).ready(function () {
    if ($(window).width() < 768) {
      var videoFile = '//cdn.shopify.com/s/files/1/0064/4697/3010/files/BG_Depth_Shot_4X5_1.mp4?15896';

      $('#v1').attr('src', videoFile);
    }
  });


  $(".hh_video_container").click(function () {
    $("#theme-yt-video-1")[0].src += "&autoplay=1&mute=0";
    ev.preventDefault();
  });

  $(".header-overlap-section").click(function () {
    $("#theme-yt-video-1")[0].src += "&autoplay=1&mute=0";
    ev.preventDefault();
  });


  $(".video-container-1").click(function () {
    $("#theme-yt-video-1")[0].src += "&autoplay=1&mute=0";
    ev.preventDefault();
  });

  $(".video-container-2").click(function () {
    $("#theme-yt-video-2")[0].src += "&autoplay=1&mute=0";
    ev.preventDefault();
  });

  $(".video-container-3").click(function () {
    $("#theme-yt-video-3")[0].src += "&autoplay=1&mute=0";
    ev.preventDefault();
  });

  
})(jQuery);



// Accordion for FAQ
var acc = document.getElementsByClassName("faq-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

//search click
$('.search-content .site-nav__search').mouseover(function(){
  $('.search-content').addClass('search-open');
});
$(document).mouseover(function(e) {
  var container = $(".search-content");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0 )
  {
  $('.search-content').removeClass('search-open');
    $('.usf-popup').css('display','none');
  }
});

// PDP tab functionality 
function openTab(cityName) {
  var i;
  var x = document.getElementsByClassName("pdp2-tab");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";  
  }
  document.getElementById(cityName).style.display = "block";  
}


// Add active class to the current button (highlight it)
var header = document.getElementById("pdp2-tab-btns");
var btns = header.getElementsByClassName("pdp-btn");
for (var i = 0; i < btns.length; i++) {
  btns[i].addEventListener("click", function() {
  var current = document.getElementsByClassName("active");
  current[0].className = current[0].className.replace(" active", "");
  this.className += " active";
  });
}
